export const NO_THANKS_CHARITY = {
  name: "No Thanks",
  charityId: null,
  total: 0,
};

function normalizeTsOrg(value) {
  return String(value || "").toLowerCase();
}

export function mapContentfulCharities(entry) {
  const items = entry?.fields?.charities || entry?.fields?.components || [];

  return items
    .map((item) => {
      const fields = item.fields || item;
      const charityId =
        fields.charityId && fields.charityId !== "null"
          ? fields.charityId
          : null;

      return {
        name: `${fields.name || ""}${
          fields.description && fields.description !== "null"
            ? ` - ${fields.description}`
            : ""
        }`,
        charityId,
        total: fields.total ?? 350,
        preselected: !!fields.preselected,
      };
    })
    .filter((item) => item.charityId && item.name);
}

export function mapContentfulCharityLists(entries = []) {
  return entries.map((entry) => {
    const fields = entry.fields || entry;
    return {
      tsOrg: fields.tsOrg || "",
      charities: mapContentfulCharities(entry),
    };
  });
}

export function withNoThanks(cmsList = []) {
  return [...cmsList, NO_THANKS_CHARITY];
}

export function charitiesFromMatchingList(lists = [], tsOrg) {
  const currentOrg = normalizeTsOrg(tsOrg);
  if (!currentOrg) return [];
  const list = lists.find(
    (item) => normalizeTsOrg(item.tsOrg) === currentOrg
  );
  return list?.charities || [];
}
